import { render, staticRenderFns } from "./Add2.vue?vue&type=template&id=504896d8&"
import script from "./Add2.vue?vue&type=script&lang=js&"
export * from "./Add2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports